export const appRoute = {
    inicio: '/',
    login: '/login',
    ato: {
        incluir: '/atos/incluir-ato',
        incluirdetalhe: '/atos/incluir-por-curadoria',
        corrigirAto: '/atos/corrigir-ato',
        republicarAto: '/atos/republicar-ato',
        republicarComparacao: '/atos/republicar-comparacao',
        gerirAtos: '/atos/gerir-atos',
        visualizarAto: '/atos/visualizar-ato',
        imprimirAto: '/atos/imprimir-ato',
    },
    consulta: {
        externa: '/consulta/externa',
        interna: '/consulta/interna',
        consultarAto: '/consulta/ato',
    },
    anotacao: {
        visualizarTipoAnotacao: '/anotacoes/tipo/visualizar',
        incluirTipoAnotacao: '/anotacoes/tipo/incluir',
        editarTipoAnotacao: '/anotacoes/tipo/editar',
        clonarTipoAnotacao: '/anotacoes/tipo/clonar',
    },
    filtros: {
        gerir: '/parametros/gerir-filtros',
        gerirManterMsg: '/parametros/gerir-filtros/1',
        novo: '/parametros/gerir-filtros/novo',
    },
    ferramentas: {
        consultarImportacoes: '/ferramentas/consultar-importacoes',
        detalharImportacao: '/ferramentas/detalhar-importacao',
    },
    tipoSegmento: {
        gerir: '/tipos-segmento/gerir-tipos-segmento',
        visualizar: '/tipos-segmento/visualizar',
        incluir: '/tipos-segmento/incluir',
        editar: '/tipos-segmento/editar',
        clonar: '/tipos-segmento/clonar',
    }
};
